/** Red circle showing how many filters/groupings are applied. */
export const CountBadge: React.FC<{ count: number }> = ({ count }) => (
  <span className="flex size-4 items-center justify-center rounded-full bg-bg-negative-strong-primary text-[10px] font-semibold text-white">
    {count}
  </span>
);
